import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import EmptyComponent from "@/components/containers/EmptyComponent";
import DashboardSkeleton from "@/components/loadings/skeleton/DashboardSkeleton";
import type { ChildRouteContext } from "@/root";

import { fetchPeriodsQueryOptions } from "@/modules/recognition/user/services";

export const Route = createFileRoute("/_panel/_recognition/recognition/top/")({
  component: Component,
  beforeLoad: async ({ context }) => {
    const period = await context.queryClient.ensureQueryData(
      fetchPeriodsQueryOptions(0),
    );
    if (period.data.length > 0) {
      throw redirect({
        to: "/recognition/top/$id",
        params: {
          id: period.data[0].id,
        },
      });
    }

    return {
      crumb: [
        {
          label: context.t("Top Employees", { ns: "recognition.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(fetchPeriodsQueryOptions(0)),
  pendingComponent: DashboardSkeleton,
});

function Component() {
  const { data: periods } = useSuspenseQuery(fetchPeriodsQueryOptions(0));
  const { t } = useTranslation("recognition.user");
  const navigate = Route.useNavigate();
  if (periods.data.length > 0) {
    navigate({
      to: "/recognition/top/$id",
      params: {
        id: periods.data[0].id,
      },
    });
  }

  return (
    <EmptyComponent
      background="grid"
      variant="document"
      title={t(
        "The top colleagues of the appreciation cycle will be visible after the cycle has ended.",
      )}
      description=""
    />
  );
}
